module.exports = __webpack_public_path__ + "img/empexportexcel.a08f7ee1.svg";